<template>
  <div class="layout__wrap" v-if="!iframe">
    <router-view :key="key"></router-view>
    <SpeedDial></SpeedDial>
  </div>
</template>

<script>
import SpeedDial from './components/SpeedDial/SpeedDial.vue';

export default {
  name: 'loginLayout', // eslint-disable-line
  components: {
    SpeedDial,
  },
  computed: {
    key() {
      return this.$route.fullPath;
    },
  },
  data() {
    return {
      iframe: true,
    };
  },
  mounted() {
    // 控制是否為iframe嵌入
    this.iframe = window.top !== window.self;
  },
};
</script>

<style lang="scss" scoped>
.layout{
  &__wrap{
    // display: flex;
  }
}
</style>
